// Generated by Melange

import * as JitsuReact from "@jitsu/jitsu-react";
import * as Buhta_cabinet__Data from "./core/Data.js";
import * as Buhta_cabinet__Home from "./Home.js";
import * as Buhta_components__ToastsList from "../../../packages/components/src/moleculas/ToastsList.js";
import * as Buhta_core__Auth from "../../../packages/core/lib/Auth.js";
import * as Buhta_core__GlobalStateContext from "../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__Tenant from "../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../packages/core/lib/Toast.js";
import * as Buhta_models__Locale from "../../../packages/models/Locale.js";
import * as Curry from "melange.js/curry.js";
import * as ReactHelmetAsync from "react-helmet-async";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function make(state) {
  return function (helmetContext) {
    return function (data) {
      const state$1 = Buhta_core__GlobalStateContext.createGlobalStateContext(state);
      const initialIdentity = Buhta_core__Auth.getInitialIdentity(state$1.prefetched, state$1.user);
      const initialCtx = Buhta_core__Tenant.getInitialCtx(state$1.ctx);
      const match = Buhta_core__Auth.useAuthContext(initialIdentity);
      const match$1 = Buhta_core__Tenant.createTenantContext(initialCtx);
      const match$2 = Buhta_cabinet__Data.useContext(data);
      const match$3 = Buhta_core__Toast.useToastsContext(/* [] */0);
      const match$4 = Buhta_models__Locale.useLocale(/* Ru */1);
      const locale = match$4[0];
      const initialPayload = state$1.payload;
      return JsxRuntime.jsx(JitsuReact.JitsuProvider, {
                  children: JsxRuntime.jsxs(ReactHelmetAsync.HelmetProvider, {
                        children: [
                          JsxRuntime.jsxs(ReactHelmetAsync.Helmet, {
                                children: [
                                  JsxRuntime.jsx("title", {
                                        children: "Бухта - онлайн бухгалтерия"
                                      }),
                                  JsxRuntime.jsx("meta", {
                                        content: "Бухта, бухгалтерия, налоговая отчетность",
                                        name: "description"
                                      }),
                                  JsxRuntime.jsx("meta", {
                                        content: "Бухта - онлайн бухгалтерия",
                                        property: "og:site_name"
                                      })
                                ]
                              }),
                          JsxRuntime.jsx(Buhta_core__GlobalStateContext.Provider.make, Buhta_core__GlobalStateContext.Provider.makeProps(state$1, JsxRuntime.jsx(ReactIntl.IntlProvider, {
                                        locale: Buhta_models__Locale.toString(locale),
                                        messages: Buhta_models__Locale.translations(locale),
                                        children: JsxRuntime.jsxs(Buhta_core__Toast.ToastsProvider.make, Buhta_core__Toast.ToastsProvider.makeProps([
                                                  match$3[0],
                                                  match$3[1]
                                                ], [
                                                  JsxRuntime.jsx(Buhta_core__Auth.IdentityProvider.make, Buhta_core__Auth.IdentityProvider.makeProps([
                                                            match[0],
                                                            match[1]
                                                          ], JsxRuntime.jsx(Buhta_core__Tenant.ContextProvider.make, Buhta_core__Tenant.ContextProvider.makeProps([
                                                                    match$1[0],
                                                                    match$1[1]
                                                                  ], JsxRuntime.jsx(Buhta_cabinet__Data.Provider.make, Buhta_cabinet__Data.Provider.makeProps([
                                                                            match$2[0],
                                                                            match$2[1]
                                                                          ], JsxRuntime.jsx(Buhta_cabinet__Home.make, {
                                                                                payload: initialPayload
                                                                              }), undefined)), undefined)), undefined)),
                                                  JsxRuntime.jsx(Buhta_components__ToastsList.make, {})
                                                ], undefined))
                                      }), undefined))
                        ],
                        context: helmetContext
                      }),
                  options: {
                    host: "https://t.buhta.com",
                    writeKey: "KrFJdzq1gqGFeSxHtmiIqXIcrD5iV0BN:cXE1KcE1iayYcUAYV8YjwsX89mkS3SoW"
                  }
                });
    };
  };
}

function App(Props) {
  return Curry._1(make(Props.state)(Props.helmetContext), Props.data);
}

const make$1 = App;

export {
  make$1 as make,
}
/* @jitsu/jitsu-react Not a pure module */
